import React from 'react';
import { motion } from 'motion/react';
import { X } from 'lucide-react';
import { cn, getDefensiveSignal } from '../../lib/utils';

interface FillEmptyPositionModalProps {
  emptyPositionToFill: string | null;
  setEmptyPositionToFill: (pos: string | null) => void;
  benchPlayers: any[];
  handleFillEmptyPosition: (playerId: string) => void;
}

export const FillEmptyPositionModal = ({
  emptyPositionToFill,
  setEmptyPositionToFill,
  benchPlayers,
  handleFillEmptyPosition
}: FillEmptyPositionModalProps) => {
  if (!emptyPositionToFill) return null;

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[70] bg-canvas flex flex-col"
    >
      <header className="p-6 border-b border-hairline flex items-center justify-between bg-raised sticky top-0 z-20">
        <div>
          <h2 className="text-xl font-black italic uppercase">Fill {emptyPositionToFill}</h2>
          <p className="text-[10px] font-bold text-ink-2 uppercase tracking-widest">Select a player from the bench</p>
        </div>
        <button onClick={() => setEmptyPositionToFill(null)} className="p-2 bg-surface rounded-lg text-ink-2 hover:text-ink">
          <X className="w-5 h-5" />
        </button>
      </header>
      <div className="flex-1 overflow-y-auto p-6 space-y-2">
        {benchPlayers.map((player: any) => (
          <button
            key={player.id}
            onClick={() => handleFillEmptyPosition(player.id)}
            className="w-full bg-surface p-4 rounded-2xl border border-hairline flex items-center space-x-4 hover:border-emerald-500/50 transition-colors text-left"
          >
            <div className="w-10 h-10 bg-hairline rounded-xl flex items-center justify-center font-black text-ink-2 relative">
              #{player.number}
              <div className={cn("absolute -top-1 -right-1 w-3 h-3 rounded-full border-2 border-surface", getDefensiveSignal(player, emptyPositionToFill))} />
            </div>
            <div className="flex-1">
              <div className="font-black uppercase text-sm">{player.name}</div>
              <div className="text-[10px] font-bold text-ink-2">
                {player.primaryPosition === emptyPositionToFill ? 'Primary Position' : 
                 player.secondaryPosition === emptyPositionToFill ? 'Secondary Position' : 'Out of Position'}
              </div>
            </div>
          </button>
        ))}
        {benchPlayers.length === 0 && (
          <div className="text-center py-12">
            <p className="text-ink-2 font-bold uppercase tracking-widest text-sm">No players on bench</p>
          </div>
        )}
      </div>
    </motion.div>
  );
};
